export interface ReturnAppendixRequest {
  collectionId: number
  revision: number
}

export function ReturnAppendixRequestToJSON(value: ReturnAppendixRequest): any {
  return {
    collection_id: value.collectionId !== 0 ? value.collectionId : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
